import { render, staticRenderFns } from "./DynamicVariableElement.vue?vue&type=template&id=3eabffdc&scoped=true&"
import script from "./DynamicVariableElement.vue?vue&type=script&lang=js&"
export * from "./DynamicVariableElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eabffdc",
  null
  
)

export default component.exports